import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { CheckInProgramRetrieve, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export interface CreateCommittedClubProgramPayload {
  name: string;
  currentThreshold: number;
  athleteVisibilityEnabled: boolean;
}

export default function useCreateCommittedClubProgram(): UseMutationResult<
  AxiosResponse<CheckInProgramRetrieve>,
  AxiosError<ErrorMessage>,
  CreateCommittedClubProgramPayload
> {
  const queryClient = useQueryClient();

  const createProgram = (
    payload: CreateCommittedClubProgramPayload,
  ): Promise<AxiosResponse<CheckInProgramRetrieve>> => client.post('check-in-program/program/', payload);

  return useMutation(createProgram, {
    onSuccess: () => {
      queryClient.invalidateQueries('committedClubProgram');
    },
  });
}
